const FLOOD_CARRIER_GROUPS = ["vave"];
const FLOOD_POLICY_TYPE = "FLD";

export const isFloodPolicy = (
  carrierGroup?: string | null,
  policyType?: string | null,
): boolean => {
  const normalizedCarrierGroup = carrierGroup?.toLowerCase() ?? "";
  return (
    FLOOD_CARRIER_GROUPS.includes(normalizedCarrierGroup) &&
    policyType === FLOOD_POLICY_TYPE
  );
};
